import { render, staticRenderFns } from "./IconButtonPlayPause.vue?vue&type=template&id=29a5f304&"
import script from "./IconButtonPlayPause.vue?vue&type=script&lang=js&"
export * from "./IconButtonPlayPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports